import React, { Component } from 'react';
import { string, bool, arrayOf, array, func } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm, FormSpy } from 'react-final-form';
import { FormattedMessage, intlShape, injectIntl } from '../../util/reactIntl';
import classNames from 'classnames';
import moment from 'moment';
// import 'moment/locale/de';
import { required, bookingDatesRequired, composeValidators } from '../../util/validators';
import { START_DATE, END_DATE } from '../../util/dates';
import { propTypes } from '../../util/types';
import config from '../../config';
import { Link } from 'react-router-dom';

import {
  Form,
  IconSpinner,
  PrimaryButton,
  FieldDateRangeInput,
  FieldSelect,
  ExternalLink,
} from '../../components';
import EstimatedBreakdownMaybe from './EstimatedBreakdownMaybe';
// import getRoomamountCodes from '../../translations/roomamountCodes';

import css from './BookingDatesForm.css';
import Imprint from '../../components/ImprintPage/Imprint';

const identity = v => v;

export class BookingDatesFormComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { focusedInput: null, seats: 1 };
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.onFocusedInputChange = this.onFocusedInputChange.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleSendEnq = this.handleSendEnq.bind(this);
  }

  // Function that can be passed to nested components
  // so that they can notify this component when the
  // focused input changes.
  onFocusedInputChange(focusedInput) {
    this.setState({ focusedInput });
  }

  // In case start or end date for the booking is missing
  // focus on that input, otherwise continue with the
  // default handleSubmit function.
  handleFormSubmit(e) {
    const { startDate, endDate } = e.bookingDates || {};
    if (!startDate) {
      e.preventDefault();
      this.setState({ focusedInput: START_DATE });
    } else if (!endDate) {
      e.preventDefault();
      this.setState({ focusedInput: END_DATE });
    }

    // --------- we added this from here --------------//
    else if (this.state.seats <= 0) {
      this.setState({ focusedInput: START_DATE });
    } else {
      e.seats = this.state.seats;
      //console.log('Seats state: ' + e.seats);

      // --------- until here --------------//

      this.props.onSubmit(e);
    }
  }

  handleSendEnq() {
    this.props.onEnquire();
  }

  // When the values of the form are updated we need to fetch
  // lineItems from FTW backend for the EstimatedTransactionMaybe
  // In case you add more fields to the form, make sure you add
  // the values here to the bookingData object.
  handleOnChange(formValues) {
    //console.log(formValues);
    const { startDate, endDate } =
      formValues.values && formValues.values.bookingDates ? formValues.values.bookingDates : {};

    var { seats } =
      formValues.values && formValues.values.seats
        ? { seats: Number(formValues.values.seats) }
        : { seats: 1 };
    this.setState({ seats: seats });
    //console.log('formaValues', formValues.values);
    //console.log('formvalues seats', formValues.values.seats);
    //console.log('SeatNumber', this.state.seats);

    const listingId = this.props.listingId;
    const isOwnListing = this.props.isOwnListing;

    if (startDate && endDate && seats && !this.props.fetchLineItemsInProgress) {
      this.props.onFetchTransactionLineItems({
        bookingData: { startDate, endDate, seats },
        listingId,
        isOwnListing,
      });
    }
  }

  render() {
    const { rootClassName, className, price: unitPrice, ...rest } = this.props;
    const classes = classNames(rootClassName || css.root, className);

    if (!unitPrice) {
      return (
        <div className={classes}>
          <p className={css.error}>
            <FormattedMessage id="BookingDatesForm.listingPriceMissing" />
          </p>
        </div>
      );
    }
    if (unitPrice.currency !== config.currency) {
      return (
        <div className={classes}>
          <p className={css.error}>
            <FormattedMessage id="BookingDatesForm.listingCurrencyInvalid" />
          </p>
        </div>
      );
    }

    return (
      <FinalForm
        {...rest}
        unitPrice={unitPrice}
        onSubmit={this.handleFormSubmit}
        render={fieldRenderProps => {
          const {
            endDatePlaceholder,
            startDatePlaceholder,
            formId,
            handleSubmit,
            intl,
            // isOwnListing,
            submitButtonWrapperClassName,
            unitType,
            values,
            timeSlots,
            fetchTimeSlotsError,
            lineItems,
            fetchLineItemsInProgress,
            fetchLineItemsError,
            bedamount,
            projectRoomtypeRaw,
            currentUser,
            isAuthenticated,
            // listingId,
            listingPathName,
            // isCustomer,
            isProvider
          } = fieldRenderProps;

          const { startDate, endDate } = values && values.bookingDates ? values.bookingDates : {};
          const seats = values && values.seats ? Number(values.seats) : 1;

          const bookingStartLabel = intl.formatMessage({
            id: 'BookingDatesForm.bookingStartTitle',
          });
          const bookingEndLabel = intl.formatMessage({
            id: 'BookingDatesForm.bookingEndTitle',
          });
          const requiredMessage = intl.formatMessage({
            id: 'BookingDatesForm.requiredDate',
          });
          const startDateErrorMessage = intl.formatMessage({
            id: 'FieldDateRangeInput.invalidStartDate',
          });
          const endDateErrorMessage = intl.formatMessage({
            id: 'FieldDateRangeInput.invalidEndDate',
          });
          const timeSlotsError = fetchTimeSlotsError ? (
            <p className={css.sideBarError}>
              <FormattedMessage id="BookingDatesForm.timeSlotsError" />
            </p>
          ) : null;

          // This is the place to collect breakdown estimation data.
          // Note: lineItems are calculated and fetched from FTW backend
          // so we need to pass only booking data that is needed otherwise
          // If you have added new fields to the form that will affect to pricing,
          // you need to add the values to handleOnChange function

          const bookingData =
            startDate && endDate && seats
              ? {
                unitType,
                startDate,
                endDate,
                seats,
              }
              : null;

          const showEstimatedBreakdown =
            bookingData && lineItems && !fetchLineItemsInProgress && !fetchLineItemsError;

          const bookingInfoMaybe = showEstimatedBreakdown ? (
            <div className={css.priceBreakdownContainer}>
              {/* <h3 className={css.priceBreakdownTitle}>
                <FormattedMessage id="BookingDatesForm.priceBreakdownTitle" />
              </h3> */}
              <EstimatedBreakdownMaybe
                listing={this.props.listing}
                seats={seats}
                bookingData={bookingData}
                lineItems={lineItems}
                projectRoomtypeRaw={projectRoomtypeRaw}
              />
            </div>
          ) : null;

          const loadingSpinnerMaybe = fetchLineItemsInProgress ? (
            <IconSpinner className={css.spinner} />
          ) : null;

          const bookingInfoErrorMaybe = fetchLineItemsError ? (
            <span className={css.sideBarError}>
              <FormattedMessage id="BookingDatesForm.fetchLineItemsError" />
            </span>
          ) : null;

          const dateFormatOptions = {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
          };

          const now = moment();
          const today = now.startOf('day').toDate();
          const tomorrow = now
            .startOf('day')
            .add(1, 'days')
            .toDate();
          const startDatePlaceholderText =
            startDatePlaceholder || intl.formatDate(today, dateFormatOptions);
          const endDatePlaceholderText =
            endDatePlaceholder || intl.formatDate(tomorrow, dateFormatOptions);
          const submitButtonClasses = classNames(
            submitButtonWrapperClassName || css.submitButtonWrapper
          );

          const seatsSelection = [...Array.from({ length: bedamount }, (v, k) => k + 1)];

          const seatsLabel =
            projectRoomtypeRaw === 'singlebedroom'
              ? intl.formatMessage(
                {
                  id: 'BookingDatesForm.singlebedroom',
                }
                // { Roomtype: Roomtype }
              )
              : projectRoomtypeRaw === 'twobedroom'
                ? intl.formatMessage(
                  {
                    id: 'BookingDatesForm.twobedroom',
                  }
                  // { Roomtype: Roomtype }
                )
                : projectRoomtypeRaw === 'doublebedroom'
                  ? intl.formatMessage(

                    {
                      id: 'BookingDatesForm.doublebedroom',
                    }
                    // { Roomtype: Roomtype }
                  )

                  : projectRoomtypeRaw === 'shared_bedroom'
                    ? intl.formatMessage(
                      {
                        id: 'BookingDatesForm.shared_bedroom',
                      }
                      // { Roomtype: Roomtype }
                    )
                    : projectRoomtypeRaw === 'entire_accomodation'
                      ? intl.formatMessage(
                        {
                          id: 'BookingDatesForm.entire_accomodation',
                        }
                        // { Roomtype: Roomtype }
                      )
                      : intl.formatMessage(
                        {
                          id: 'BookingDatesForm.camping',
                        }
                        // { Roomtype: Roomtype }
                      );         
          const emailVerified = currentUser ? currentUser.attributes.emailVerified : false
          //console.log("in booking current user", currentUser)
          const bookingButtonDisabled = !isAuthenticated || !emailVerified || !showEstimatedBreakdown || isProvider
          const loginErrorTitle = intl.formatMessage({id: 'BookingDatesForm.loginError'});
          return (
            <Form onSubmit={handleSubmit} className={classes}>
              {timeSlotsError}
              <FormSpy
                subscription={{ values: true }}
                onChange={values => {
                  this.handleOnChange(values);
                }}
              />

              <FieldSelect name="seats" id="seats" className={css.field} label={seatsLabel}>
                {seatsSelection.map((person, index) => {
                  return (
                    <option key={index} value={person}>
                      {person}
                    </option>

                  );
           
                })}
              </FieldSelect>

              <FieldDateRangeInput
                className={css.bookingDates}
                name="bookingDates"
                unitType={unitType}
                startDateId={`${formId}.bookingStartDate`}
                startDateLabel={bookingStartLabel}
                startDatePlaceholderText={startDatePlaceholderText}
                endDateId={`${formId}.bookingEndDate`}
                endDateLabel={bookingEndLabel}
                endDatePlaceholderText={endDatePlaceholderText}
                focusedInput={this.state.focusedInput}
                onFocusedInputChange={this.onFocusedInputChange}
                format={identity}
                timeSlots={timeSlots}
                useMobileMargins
                validate={composeValidators(
                  required(requiredMessage),
                  bookingDatesRequired(startDateErrorMessage, endDateErrorMessage)
                )}
                disabled={fetchLineItemsInProgress}
              />

              {bookingInfoMaybe}
              {loadingSpinnerMaybe}
              {bookingInfoErrorMaybe}

              {bookingButtonDisabled && <span style={{ color: '#808080' }}><FormattedMessage id="BookingDatesForm.selectDate" /></span>}

              <div className={submitButtonClasses}>

                <PrimaryButton title={!isAuthenticated &&   loginErrorTitle}  type="submit" disabled={bookingButtonDisabled}>
                  <FormattedMessage id="BookingDatesForm.requestToBook" />
                </PrimaryButton>
                {showEstimatedBreakdown ?
                  isAuthenticated ?
                    emailVerified ?
                      null
                      :
                      <u>
                        <Link to={`/account/contact-details`}>
                          <FormattedMessage id="BookingDatesForm.emailVerificatioError" />
                        </Link>
                      </u>
                    : <u>
                      <Link to={{ pathname: `/login`, state: { listingPathName: `${listingPathName}` } }}>
                        <FormattedMessage id="BookingDatesForm.authorizationError" />
                      </Link>
                    </u>
                  : null
                }
                {isProvider ? <div>
                  <FormattedMessage id="BookingDatesForm.providerError" />

                </div> : null}
              </div>


            </Form>
          );
                
        }}
      />

    );
  }
}

BookingDatesFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  submitButtonWrapperClassName: null,
  price: null,
  isOwnListing: false,
  startDatePlaceholder: null,
  endDatePlaceholder: null,
  timeSlots: null,
  lineItems: null,
  fetchLineItemsError: null,
};

BookingDatesFormComponent.propTypes = {
  rootClassName: string,
  className: string,
  submitButtonWrapperClassName: string,

  unitType: propTypes.bookingUnitType.isRequired,
  price: propTypes.money,
  isOwnListing: bool,
  timeSlots: arrayOf(propTypes.timeSlot),

  onFetchTransactionLineItems: func.isRequired,
  lineItems: array,
  fetchLineItemsInProgress: bool.isRequired,
  fetchLineItemsError: propTypes.error,

  // from injectIntl
  intl: intlShape.isRequired,

  // for tests
  startDatePlaceholder: string,
  endDatePlaceholder: string,
};

const BookingDatesForm = compose(injectIntl)(BookingDatesFormComponent);
BookingDatesForm.displayName = 'BookingDatesForm';

export default BookingDatesForm;
